import {
  TaxDiagnosticSummaryAccordion,
} from 'Views/Page/Content/Templates/TaxDiagnosticTaxStrategiesSummaryStep/TaxDiagnosticSummaryAccordion';
import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { FDPaper, FDTitleText, FDStack } from '@facet-wealth/design';
import { useLottieLoadingContext } from 'Components/ComponentLibrary/Organisms/LottieControl/LottieLoadingLayout';
import {
  TaxDiagnosticHeaderLottie,
} from 'Views/Page/Content/Templates/TaxDiagnosticCommon/TaxDiagnosticHeaderLottie/TaxDiagnosticHeaderLottie';

export const TaxDiagnosticSummaries = ({ title, value, lottieRelationship }) => {
  const { setIsContentShowing } = useLottieLoadingContext();

  React.useEffect(() => {
    setIsContentShowing(false);
  }, []);

  const sections = value.resources().list();

  return (
    <FDPaper padding={2} appearance="elevated">
      <FDStack direction="column" spacing={2}>
        {lottieRelationship ? (
          <TaxDiagnosticHeaderLottie src={lottieRelationship.link('related').url()} />
        ) : null }
        <FDTitleText value={title} align="center" size="lg" />
        <FDStack direction="column">
          {sections.map((section) => (
            <TaxDiagnosticSummaryAccordion key={section.id()} section={section} />
          ))}
        </FDStack>
      </FDStack>
    </FDPaper>
  );
};

TaxDiagnosticSummaries.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.instanceOf(fr.Collection).isRequired,
  lottieRelationship: PropTypes.object.isRequired,
};
